import { Injectable } from '@angular/core';
import {
     ActivatedRouteSnapshot,
     CanActivate,
     Router,
     RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';

@Injectable()
export class NotLoggedGuard implements CanActivate {
     constructor(private router: Router, private session: SessionService) {}

     canActivate(
          next: ActivatedRouteSnapshot,
          state: RouterStateSnapshot
     ): Observable<boolean> | Promise<boolean> | boolean {
          if (this.session.get()) {
               this.router.navigateByUrl('/app');
               return false;
          } else {
               return true;
          }
     }
}
